<template>
    <div class="file-upload">

        <!-- INPUT FILE (caché si mode caméra) -->
        <input ref="fileInput" type="file" @change="handleFileChange" class="hidden" />

        <!-- MODE INPUT CLASSIQUE -->
        <div v-if="mode === 'input'" class="mb-4">
            <input type="file" @change="handleFileChange" class="bg-white border border-gray-300 rounded p-2 w-full" :id="id" :accept="accept" />
        </div>

        <!-- MODE BOUTON CAMÉRA -->
        <div v-if="mode === 'camera'" class="mb-4">
            <button type="button" @click="openFileDialog" class="w-full h-32 flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-red-400 bg-red-50 active:bg-red-100 transition">
                <i class="fas fa-camera text-3xl text-red-600"></i>
                <span class="text-red-700 font-semibold">
                    Prendre ou ajouter une photo
                </span>
            </button>
        </div>

        <!-- PREVIEW -->
        <div v-if="preview && previewUrl" class="mb-4">
            <img :src="previewUrl" alt="Preview" class="mx-auto rounded-lg shadow max-h-64 object-contain" />
        </div>

        <!-- UPLOADING -->
        <p v-if="uploading" class="text-red-500 font-semibold">
            Upload en cours...
        </p>

        <!-- PROGRESS -->
        <div v-if="uploading" class="w-full bg-gray-200 h-2 rounded mt-3">
            <div class="bg-red-500 h-2 rounded transition-all duration-200" :style="{ width: progress + '%' }"></div>
        </div>

        <!-- ERROR -->
        <div v-if="error" class="mt-2 text-red-500">
            Erreur : {{ error }}
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "FileUploader",
    props: {
        value: { type: String, default: "" },
        keyName: { type: String, required: true },
        filename: { type: String, default: "" },
        preview: { type: Boolean, default: true },
        mode: { type: String, default: "input" }, // input | camera
        id: { type: String, default: null },
        accept: { type: String, default: "*" }
    },
    data() {
        return {
            uploading: false,
            error: null,
            progress: 0,
            previewUrl: null
        };
    },
    methods: {
        openFileDialog() {
            this.$refs.fileInput.click();
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.handleFile(file);
            }
        },
        handleFile(file) {
            this.previewUrl = URL.createObjectURL(file);
            this.uploadFile(file);
        },
        async uploadFile(file) {
            this.uploading = true;
            this.error = null;
            this.progress = 0;

            try {
                const formData = new FormData();
                formData.append("key_name", this.keyName);
                if (this.filename) {
                    formData.append("filename", this.filename);
                }
                formData.append("file", file);

                const response = await axios.post(
                    "https://storage.termoflow.fr/upload.php",
                    formData,
                    {
                        headers: {
                            "Authorization": "Bearer PRODt1ntH4nCMTfw5tGrXy0ZRgyz4Q",
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: (e) => {
                            if (e.lengthComputable) {
                                this.progress = Math.round((e.loaded * 100) / e.total);
                            }
                        }
                    }
                );

                if (!response.data?.success) {
                    throw new Error("Upload échoué");
                }

                this.$emit("input", response.data.url);
                this.previewUrl = this.preview ? response.data.url : null;

            } catch (err) {
                this.error = err.response?.data?.message || err.message || "Erreur inconnue";
                this.previewUrl = null;
            } finally {
                this.uploading = false;
            }
        }
    }
};
</script>
